export const FLAT = 'FLAT';
export const TIERED = 'TIERED';